import { CacheStrategy } from '@rammetec/data-access';
import { AUDIT_FIELD_DESCRIPTORS, AUDIT_FOREIGN_KEYS } from './_auditFields.js';
import { LIFECYCLE_FIELD_DESCRIPTORS } from './_lifecycleFields.js';
import { BUSINESS_ALLOWED_DATA_SOURCES, BUSINESS_DEFAULT_DATA_SOURCE } from './dataSourcePolicy.js';
import { SECTOR } from '../types/sector.js';
import { WORK_CALENDAR } from '../types/work-calendar.js';
import { FIELD_LIMITS } from '../validation/fieldLimits.js';
/**
 * Descriptor for Sector entity.
 * Stored in 'org/{orgId}/sector'.
 */
export const sectorDescriptor = {
    name: SECTOR,
    label: 'Setor',
    domain: 'catalog',
    collectionPath: 'org/{orgId}/sector',
    pathPatternKeys: {
        orgId: 'string',
    },
    version: 3,
    description: 'Productive sector of the company',
    repositoryConfig: {
        dataSource: BUSINESS_DEFAULT_DATA_SOURCE,
        cache: CacheStrategy.InMemory,
    },
    allowedDataSources: BUSINESS_ALLOWED_DATA_SOURCES,
    fields: [
        {
            name: 'id',
            label: 'ID',
            type: 'string',
            required: true,
            description: 'Unique sector identifier',
        },
        {
            name: 'code',
            example: 10,
            label: 'Código',
            type: 'number',
            display: 'code',
            required: true,
            unique: true,
            autoNumber: true,
            description: 'Numeric sector code (master-data identifier; non-negative, capped at MAX_CODE_SMALL)',
        },
        {
            name: 'description',
            example: 'Tinturaria',
            label: 'Descrição',
            type: 'string',
            required: true,
            maxLength: FIELD_LIMITS.NAME,
            description: 'Sector description',
        },
        {
            name: 'factoryId',
            label: 'Fábrica',
            type: 'string',
            required: false,
            description: 'Optional factory (productive plant) this sector belongs to',
        },
        {
            name: 'workCalendarId',
            label: 'Calendário de trabalho',
            type: 'string',
            required: false,
            description: 'Optional work calendar (overrides the factory calendar for this sector)',
        },
        {
            name: 'productionInstructions',
            example: 'Seguir receita do processo e validar pH antes do enxágue',
            label: 'Instruções de produção',
            type: 'string',
            required: false,
            description: 'Production instructions for the sector',
        },
        ...LIFECYCLE_FIELD_DESCRIPTORS,
        ...AUDIT_FIELD_DESCRIPTORS,
    ],
    foreignKeys: [
        ...AUDIT_FOREIGN_KEYS,
        {
            fieldName: 'factoryId',
            targetEntity: 'Factory',
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'The factory this sector belongs to',
        },
        {
            fieldName: 'workCalendarId',
            targetEntity: WORK_CALENDAR,
            relationship: 'many-to-one',
            displayField: 'description',
            description: 'Optional work calendar for this sector',
        },
    ],
};
//# sourceMappingURL=sector.descriptor.js.map